import React from "react";
import { Navigate, generatePath } from "react-router-dom";
import track from "react-tracking";

import { Flex } from "@chakra-ui/react";

import CompleteView from "components/Trips/Complete/CompleteView";
import { PAGE_PATHS } from "config/routes";
import { Loader } from "elements";
import useFetchOffers from "hooks/api/offers/useFetchOffers";
import { PRODUCTS_NAME } from "types/products";
import { usePageTracking } from "utils/tracking";

const CompletePage: React.FC = () => {
  usePageTracking();

  const { isLoading: isLoadingOffers, isError: isErrorOffers, data: offersData } = useFetchOffers();

  if (isLoadingOffers) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100%" mx="auto">
        <Loader dataTestId="loader" />
      </Flex>
    );
  }

  if (isErrorOffers) {
    return <Navigate to={generatePath(PAGE_PATHS.ERROR_PAGE)} />;
  }

  if (!offersData) {
    return null;
  }

  const offers = offersData.offers;
  const product = offers[PRODUCTS_NAME.UPGRADE_TO_TRIP_COMPLETE];
  return <CompleteView product={product} />;
};

export default track({ page_type: "Trips.Upgrade.Complete" })(CompletePage);
